import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { Component, OnInit, ViewChild, OnDestroy, ViewChildren, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomerService } from 'src/app/core/services/customer.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { CommonService } from 'src/app/core/services/common.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from 'src/app/core/services/storage.service';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatOption, MatSelect } from '@angular/material';
import { AlertComponent } from '../../../../../../shared/components/alert/alert.component';
import {
  ImportCustomerFileComponent
} from '../../../../../../shared/components/ImportCustomerFile/import-customer-file.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ResponsiveService } from '../../../../../../core/services/responsive.service';
import {
  Document,
  DocumentKeyPair, PaginateKeyPair, SortKeyPair
} from "../../document/search-document-sign/search-document-sign.component";
import { MatSort } from "@angular/material/sort";
import { Paginate } from "../../document/document-group-manage/document-group-manage.component";
import {
  DeleteAllCustomersDialogComponent
} from "../../document/delete-all-customers-dialog/delete-all-customers-dialog.component";
import { AssignGroupCustomerDialogComponent } from './assign-group-customer-dialog/assign-group-customer-dialog.component';
import { NotifyExportDataCustomerComponent } from 'src/app/shared/components/notify-export-data-customer-dialog/notify-export-data-customer-dialog.component';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { NotifyExportDataCustomerSuccessComponent } from 'src/app/shared/components/notify-export-data-customer-success-dialog/notify-export-data-customer-success-dialog.component';
import { DialogSyncCustomerComponent } from './dialog-sync-customer/dialog-sync-customer.component'
import {environment} from "../../../../../../../environments/environment";
import { EnvService } from 'src/app/core/services/env.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit, OnDestroy, AfterViewInit {

  isTableLoading = false;
  @ViewChild('allSelectedGroup', { static: false }) allSelectedGroup: MatOption;
  @ViewChild('groupSelect', { static: false }) groupSelect: MatSelect;
  customer = {
    enterpriseId: localStorage.getItem('enterpriseId'),
    tenantId: localStorage.getItem('tenantId'),
    name: '',
    foreignName: '',
    abbreviation: '',
    taxCode: '',
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    types: null,
    certificateId: null,
    certificateNo: '',
    issuedDate: '',
    issuedAt: '',
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeCertificate: '',
    representativeIssuedDate: '',
    representativeIssuedOn: '',
    birthday: '',
    sex: null,
    businessType: null,
    enterpriseTypeId: 'null',
    status: null,
    isDeleted: null,
    files: '',
    cityId: null,
    wardId: null,
    districtId: null,
    address: '',
    taxCodeOrCertificateNo: null,
    taxCodeOrCertificate: null,
    customerType: null,
    emailOrPhoneOrName: null,
    customerGroupNames: [],
    customerCode:null
  };
  isBasicSearchForm = true
  group = {
    id: [],
    createdTime: '',
    description: '',
    name: '',
  }

  // dataSource: DocumentDataSource;
  checkAll: boolean;
  enterpriseType: comboBox[] = [];
  dataSelected: Map<any, Document> = new Map<any, Document>();
  documents = new Document();
  parentDocuments: Document[];
  childOldDataList: DocumentKeyPair = {};
  childPaginateList: PaginateKeyPair = {};
  childSortList: SortKeyPair = {};
  childIsExpanding: Array<string>;
  groupData: comboBox[] = [];
  GroupCustomersId = []
  GroupCustomersFilterCtrl: FormControl = new FormControl();
  public filteredGroupCustomers: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  enterpriseTypeFilterCtrl: FormControl = new FormControl();

  public filteredEnterpriseType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();

  checkFocus = true;
  enterpriseList: any;
  // displayedColumns: string[] = ['id', 'name', 'certificateNo', 'address', 'email', 'phone', 'symbol'];
  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "check", showMobile: true },
    { def: "id", showMobile: true },
    { def: "customerCode", showMobile: true },
    { def: "name", showMobile: true },
    { def: "groupName", showMobile: true },
    { def: "certificateNo", showMobile: true },
    { def: "address", showMobile: false },
    { def: "email", showMobile: false },
    { def: "phone", showMobile: false },
    { def: "customerType", showMobile: false },
    { def: "action", showMobile: true },
  ];

  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  oldData = this.customer;
  paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  cities: { id: number, name: '', description: '' }[];
  districts: { id: number, cityId: number, name: '', description: '' }[];
  wards: { id: number, districtId: number, name: '', description: '' }[];
  error = '';
  subscription: Subscription;
  personalId = EnterpriseTypes.PERSONAL;
  permissions: any;
  userId: any;

  // Variable for saving userType from session storage of current user
  userType: number;
  enterpriseTypeI18n = new Map();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('enterpriseTypeSelect', { static: false }) enterpriseTypeSelect: MatSelect;
  @ViewChild('statusSelect', { static: false }) statusSelect: MatSelect;
  public enterpriseId: string;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  isNotAttestedUser: boolean = false;
  isBuyTwoService: boolean = false
  isDefaultAdmin: boolean = false
  sme_hub:any;
  constructor(
    public notificationService: NotificationService,
    public dialog: MatDialog,
    private customerService: CustomerService,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private message: Message,
    private toastr: ToastrService,
    private storageService: StorageService,
    public customerFilter: CustomerFilterLanguage,
    private responsiveService: ResponsiveService,
    public deviceService: DeviceDetectorService,
    private env:EnvService
  ) {
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    this.isBuyTwoService = this.commonService.checkBuyTwoServiceWithoutHauntAndAdminAndPermissionCustomer();
    this.isDefaultAdmin = this.commonService.checkDefaultAdmin()
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
    this.userId = localStorage.getItem('userId');
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.setUserType();
    this.sme_hub = env.sme_portal_url
  }

  /**
   * Get initial data
   */
  ngOnInit() {
    this.setValueI18nToMap();
    this.enterpriseTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.enterpriseType, this.enterpriseTypeFilterCtrl, this.filteredEnterpriseType); });
    this.GroupCustomersFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        value => {
          this.commonService.filterCertificateType(this.groupData, this.GroupCustomersFilterCtrl, this.filteredGroupCustomers);
        });
    this.getEnterpriseType();
    this.getGroupCustomer()
    this.getCities();
    this.getDistricts();
    this.getWards();
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  getGroupCustomer() {
    this.customerService.filterCustomerGroups({
      page: 0,
      pageSize: 99999,
      keyword: this.GroupCustomersFilterCtrl.value
    }).subscribe(res => {
      if (res) {
        this.groupData = res.data.content
        this.filteredGroupCustomers.next(res.data.content.slice());

      }
    })
  }

  clickOptionServiceTypeAll() {
    // if (this.documents.serviceTypeId.length > 1) {
    //   this.documents.serviceTypeId = [-1];
    // }

    if (this.allSelectedGroup.selected) {
      this.groupSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
    } else {
      this.groupSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
    }
  }

  clickOptionServiceType() {
    // if (this.documents.serviceTypeId[0] === -1 && this.documents.serviceTypeId.length > 1) {
    //   this.documents.serviceTypeId = this.documents.serviceTypeId.filter(id => id !== -1);
    // }

    if (this.allSelectedGroup.selected) {
      this.allSelectedGroup.deselect();
    }
    if (this.groupSelect.options.length - 2 == this.group.id.length) {
      this.allSelectedGroup.select();
    }
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  setValueI18nToMap() {
    this.enterpriseTypeI18n.set(10000, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_personal');
    this.enterpriseTypeI18n.set(10001, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_private_company');
    this.enterpriseTypeI18n.set(10002, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_authority');
    this.enterpriseTypeI18n.set(10003, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_type_government_agencies');
    this.enterpriseTypeI18n.set(10004, 'enterprise_customer_management.cbx_custommer_type.cbx_custommer_state_enterprise');
    this.enterpriseTypeI18n.set(10005, 'enterprise_customer_management.cbx_custommer_type.cbx_individual_business_households');
  }

  /**
   * Get user type from session storage and set to userType variable
   */
  setUserType() {
    this.userType = this.storageService.getUserTypeFromSessionStorage();
  }

  /**
   * Get cities list from local storage or api
   */
  getCities() {
    if (localStorage.getItem('cities') === null) {
      this.commonService.getAllCityRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.cities = data;
          localStorage.setItem(
            'cities',
            JSON.stringify(this.cities),
          );
        }
      });
    } else {
      this.cities = JSON.parse(
        localStorage.getItem('cities')
      );
    }
  }

  /**
   * Get districts list from local storage or api
   */
  getDistricts() {
    if (localStorage.getItem('districts') === null) {
      this.commonService.getAllDistrictsRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.districts = data;
          localStorage.setItem(
            'districts',
            JSON.stringify(this.districts),
          );
        }
      });
    } else {
      this.districts = JSON.parse(
        localStorage.getItem('districts')
      );
    }
  }

  onImportFile() {
    if(this.checkRouterSSO() == true){
      return
    }else{
      this.router.navigate(['home-enterprise/import-customer']);
  }
    // const dialogRe = this.dialog.open(ImportCustomerFileComponent, {
    //   width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '550px',
    //   maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
    //   // panelClass: 'scontract-overlay-dialog',
    //   data: this.message.getMessage('messages.confirm_change_data')
    // });
    // dialogRe.afterClosed().subscribe(res => {
    //   this.commonService.getEnterpriseType().subscribe(rs => {
    //       this.getEnterpriseType();
    //   });
    // })
  }

  /**
   * Get wards list from local storage or api
   */
  getWards() {
    if (localStorage.getItem('wards') === null) {
      this.commonService.getAllWardRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.wards = data;
          localStorage.setItem(
            'wards',
            JSON.stringify(this.wards),
          );
        }
      });
    } else {
      this.wards = JSON.parse(
        localStorage.getItem('wards')
      );
    }
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status' && cd.def !== 'check'))
    //     .map(cd => cd.def);
    // }
  }

  /**
   * Load all customer, lazy loading
   * @param page: number
   * @param pageSize: number
   */
  loadData(page: number = 0, pageSize: number = 10) {
    let tempTenantId: any;
    let keyword: '';
    let paramEnterpriseTypeId: [];
    let paramStatus: [];
    let paramTaxCodeOrCertificateNo: '';

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        tempTenantId = params.tenantId;
        // Defaults to 0 if no query param provided.
        if (typeof tempTenantId !== 'undefined') {
          page = params.page || 0;
          pageSize = params.pageSize || 10;
          keyword = params.keyword || '';
          paramEnterpriseTypeId = params.enterpriseTypeId ? params.enterpriseTypeId.split(',').map(function (item: string) {
            return parseInt(item, 10);
          }) : this.enterpriseList;
          paramStatus = params.status ? params.status.split(',').map(function (item: string) {
            return parseInt(item, 10);
          }) : [0, 1];
          paramTaxCodeOrCertificateNo = params.taxCodeOrCertificateNo || '';
        }
      });


    if (typeof tempTenantId !== 'undefined') {
      this.customer.emailOrPhoneOrName = keyword;
      this.customer.taxCodeOrCertificateNo = paramTaxCodeOrCertificateNo;
      this.customer.taxCodeOrCertificate = paramTaxCodeOrCertificateNo;
      this.customer.status = paramStatus.length > 1 ? 'null' : paramStatus.toString();
      this.customer.enterpriseTypeId = paramEnterpriseTypeId.length > 1 ? 'null' : paramEnterpriseTypeId.toString();
    }

    if ((this.userType !== -1 && this.userType !== 2) || this.checkDisplayFullList()) {
      this.isTableLoading = true;
      // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
      // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
      this.dataSource.data = [];
      this.customerService.filterCustomers({
        tenantId: localStorage.getItem('tenantId'),
        page,
        pageSize,
        enterpriseId: localStorage.getItem('enterpriseId'),
        keyword: typeof tempTenantId !== 'undefined' ? keyword : '',
        enterpriseTypeId: typeof tempTenantId !== 'undefined' ? paramEnterpriseTypeId : this.enterpriseList,
        status: typeof tempTenantId !== 'undefined' ? paramStatus : [0, 1],
        taxCodeOrCertificateNo: typeof tempTenantId !== 'undefined' ? paramTaxCodeOrCertificateNo : null,
        customerCode: this.customer.customerCode
        // "enterpriseId": 1
      }).subscribe(
        rs => {
          this.isTableLoading = false;
          console.log('30945834905834095348095 loadData');
          this.bindData(rs);
        }, () => this.isTableLoading = false
      );
    } else if (this.userType === 2 && !this.checkDisplayFullList()) {
      this.isTableLoading = true;
      // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
      // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
      this.dataSource.data = [];
      this.customerService.filterCustomersForGuest({
        tenantId: localStorage.getItem('tenantId'),
        page,
        pageSize,
        taxCodeOrCertificate: this.oldData.taxCodeOrCertificate,
        customerCode: this.customer.customerCode

      }).subscribe(
        rs => {
          this.isTableLoading = false;
          this.bindData(rs);
        }, () => this.isTableLoading = false
      );
    }
  }

  /**
   * On click button delete customer
   */
  onClickIconDelete(customerId: number, customerName: string) {
    if(localStorage.getItem('isFromSSO') =='true' ){
      window.open(this.sme_hub+'/admin/object-management','_blank');
      return
  }
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_customer'), customerName)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.customerService.deleteCustomer(customerId).subscribe(
          () => {
            this.toastr.success(this.message.getMessage('messages.delete_success'));
            if (this.paginate.totalRow % this.paginate.pageSize === 1) {
              if (this.paginate.currentPage - 1 < 0) {
                this.paginate.currentPage = 0;
              } else {
                this.paginate.currentPage = this.paginate.currentPage - 1;
              }
            }
            this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
            this.dataSelected.delete(customerId);
          }
        );
      }
      this.focusInput.first.nativeElement.focus();
    });
  }

  /**
   * Filter customer
   */

  onFilterCustomers(page: number = 0, pageSize: number = 10) {
    const status: [] | any = this.oldData.status == null || this.oldData.status === 'null' ? [0, 1] : [Number(this.oldData.status)];
    const enterpriseTypeId: [] | any = this.oldData.enterpriseTypeId == null ||
      this.oldData.enterpriseTypeId === 'null' ? this.enterpriseList : [this.oldData.enterpriseTypeId];
    if ((this.userType !== -1 && this.userType !== 2) || this.checkDisplayFullList()) {
      this.isTableLoading = true;
      // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
      // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
      this.dataSource.data = [];
      this.customerService.filterCustomers({
        tenantId: localStorage.getItem('tenantId'),
        page,
        pageSize,
        enterpriseId: localStorage.getItem('enterpriseId'),
        taxCodeOrCertificateNo: this.oldData.taxCodeOrCertificateNo,
        keyword: this.oldData.emailOrPhoneOrName,
        status,
        enterpriseTypeId,
        idCustomerGroupList: this.group.id,
        customerCode: this.customer.customerCode
      }).subscribe(
        rs => {
          this.isTableLoading = false;
          console.log('30945834905834095348095 onFilterCustomers');
          this.bindData(rs);
        }, () => this.isTableLoading = false
      );
    } else if (this.userType === 2 && !this.checkDisplayFullList()) {
      this.isTableLoading = true;
      // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
      // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
      this.dataSource.data = [];
      this.customerService.filterCustomersForGuest({
        tenantId: localStorage.getItem('tenantId'),
        page,
        pageSize,
        taxCodeOrCertificate: this.oldData.taxCodeOrCertificate,
        customerCode: this.customer.customerCode
      }).subscribe(
        rs => {
          this.isTableLoading = false;
          this.bindData(rs);
        }, () => this.isTableLoading = false
      );
    }
  }

  public onSelectionChange(element) {
    if (element.checked) {
      this.dataSelected.set(element.id, element);
    } else {
      this.dataSelected.delete(element.id);
    }
    this.checkCheckAll();
  }

  checkCheckAll() {
    let data = this.dataSource.data;
    for (let i = 0; i < data.length; i++) {
      const currentRow = data[i];
      if (!this.dataSelected.has(currentRow.id)) {
        this.checkAll = false;
        break;
      }
      if (i === data.length - 1) {
        this.checkAll = true;
      }
    }
  }

  public checkAllDocument() {
    this.dataSource.data.forEach(data => {
      data.checked = this.checkAll;
      this.dataSelected.set(data.id, data);
      if (!this.checkAll) {
        this.dataSelected.delete(data.id);
      }
    });
  }


  /**
   * Bind data from api
   */
  private bindData(rs: any) {
    console.log('rs bindData', rs)
    if (rs == null || rs.data == null || rs.data.dataRow == null) {
      return 0;
    }
    this.paginate = {
      currentPage: rs.data.currentPage,
      pageSize: rs.data.pageSize,
      totalRow: rs.data.totalRow,
      totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
      totalPageArray: this.commonService.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
      no: this.commonService.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
    };
    this.dataSource.data = rs.data.dataRow;
    if (this.cities !== undefined && this.districts !== undefined && this.wards !== undefined) {
      this.dataSource.data = this.dataSource.data.map((x: any) => {
        return {
          ...x,
          address: x.address + `, ${this.commonService.getWardName(this.wards, x.wardId).name}, ${this.commonService.getDistrictName(this.districts, x.districtId).name}, ${this.commonService.getCityName(this.cities, x.cityId).name}`
        };
      });
    }
    /* đối chiếu list mới trả về và danh sách object đã check */
    // nếu mà map object đã check tồn tại ở trong list hiện => chuyển trạng thái thành checked = true
    this.initParent(rs);
    this.checkCheckAll();
  }

  /**
   * Bind old search data to variable oldData to avoid error
   */
  onClickBtnFilter() {
    this.oldData = { ...this.customer };
  }

  /**
   * Open advanced search form
   */
  onExpandAdvancedSearchForm() {
    this.isBasicSearchForm = false;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Close advanced search form
   */
  onCloseAdvancedSearchForm() {
    this.isBasicSearchForm = true;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   *
   */
  onClickBtnAdd() {
    // changes the route without moving from the current view or
    // triggering a navigation event,
    this.router.navigate(['/home-enterprise/add-customer'], {
    });
  }

  /**
   * when click btn Update
   */
  onClickBtnViewUpdate(route: string, id: string) {
    if(route == '/home-enterprise/update-customer/' && localStorage.getItem('isFromSSO') =='true' ){
        window.open(this.env.sme_portal_url+'/admin/object-management','_blank');
        return
    }
    const status: [] | any = this.oldData.status == null || this.oldData.status === 'null' ? [0, 1] : [Number(this.oldData.status)];
    const enterpriseTypeId: [] | any = this.oldData.enterpriseTypeId == null ||
      this.oldData.enterpriseTypeId === 'null' ? this.enterpriseList : [this.oldData.enterpriseTypeId];
    // changes the route without moving from the current view or
    // triggering a navigation event,
    this.router.navigate([route + id], {
      queryParams: {
        tenantId: localStorage.getItem('tenantId'),
        page: this.paginate.currentPage,
        pageSize: this.paginate.pageSize,
        enterpriseId: localStorage.getItem('enterpriseId'),
        taxCodeOrCertificateNo: this.userType === 2 && !this.checkDisplayFullList() ? this.oldData.taxCodeOrCertificate
          : this.oldData.taxCodeOrCertificateNo,
        status: status.toString(),
        enterpriseTypeId: enterpriseTypeId.toString(),
        keyword: this.oldData.emailOrPhoneOrName,
        customerType: this.oldData.customerType
      }
    });
  }

  /**
   * Get wards list from local storage or api
   */
  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.enterpriseType = result;
        this.filteredEnterpriseType.next(this.enterpriseType.slice());
        this.enterpriseList = this.enterpriseType.map(x => {
          return x.id;
        });
        this.loadData();
      }
    });
  }
  getEnterpriseTypeOptions(options) {
    return this.customerFilter.filterOptionsData(options);
  }

  deleteAll(selectedSizes: number) {
    if(localStorage.getItem('isFromSSO') =='true'){
      window.open(this.sme_hub+'/admin/object-management','_blank');
      return
  }
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '500px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_list_customers'), selectedSizes),
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        const ids = [];
        for (const item of this.dataSelected.values()) {
          ids.push(item.id);
        }
        this.customerService.deleteAll(ids).subscribe(result => {
          // console.log(result);
          if (result.data) {
            this.openDialogDeleteAll(result.data);
          }
        })
      }
    })
  }

  openDialogDeleteAll(result) {
    // document.getElementById('toggleBar').click();
    const dialogRef = this.dialog.open(DeleteAllCustomersDialogComponent, {
      width: this.deviceService.isMobile() ? '100%' : '50%',
      maxWidth: this.deviceService.isMobile() ? '90vw' : '80vw',
      // panelClass: 'scontract-overlay-dialog',
      disableClose: true,
      data: result,
    });
    dialogRef.afterClosed().subscribe(() => {
      if (this.paginate.totalRow % this.paginate.pageSize === 1) {
        if (this.paginate.currentPage - 1 < 0) {
          this.paginate.currentPage = 0;
        } else {
          this.paginate.currentPage = this.paginate.currentPage - 1;
        }
      }
      this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
      this.dataSelected.clear();
    });
  }

  exportData(isExportFullCustomerInformation: boolean) {
    const dialogRef = this.dialog.open(NotifyExportDataCustomerComponent, {
      data: {
        typeDialog: isExportFullCustomerInformation ? 'export_customer_full' : 'export_customer_compact',
        countCustomer: Array.from(this.dataSelected.keys()).length
      },
      width: '40%'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== false) {
        let data = {
          requestExportCustomerGroup: {
            customerGroupIds: null,
            customerIds: Array.from(this.dataSelected.keys()),
            isExportByGroup: false,
            isExportFullCustomerInformation: isExportFullCustomerInformation
          }
        }
        this.customerService.createExportExcelHistory(data).subscribe({
          next: (rs) => {
            if (rs && (rs.code == ErrorCode.ExportGroupCustomerNotFound || rs.code == ErrorCode.ExportGroupCustomerNotPermission || rs.code == ErrorCode.ExportCustomerNotPermission || rs.code == ErrorCode.ExportCustomerNotFound)) {
              this.toastr.error(rs.message);
              return;
            }
            if (rs == null || rs.data == null) {
              return 0;
            }
            if (result == 'export') {
              const dialogRef = this.dialog.open(NotifyExportDataCustomerSuccessComponent, {
                width: '550px'
              });
              return;
            }
            if (result == 'export_and_view') {
              this.router.navigate(['/home-enterprise/export-data-customer']);
              return;
            }
          }
        })
      }
    });
  }

  // onFilterData() {
  //   this.customerService.filterCustomers(
  //     {
  //       ...this.documents,
  //       ...this.paginate,
  //       page: this.paginate.currentPage,
  //     }
  //   ).subscribe(result => {
  //     // console.log(result)
  //     // console.log(this.dataSource)
  //     const {data} = result;
  //     this.paginate = {
  //       ...this.paginate,
  //       currentPage: data.currentPage,
  //       pageSize: data.pageSize,
  //       totalRow: data.totalRow,
  //       totalPage: Math.ceil(data.totalRow / data.pageSize),
  //       totalPageArray: this.commonService.counter(Math.ceil(data.totalRow / data.pageSize), 1),
  //       no: this.commonService.counter(data.pageSize, data.currentPage * data.pageSize + 1)
  //     };
  //     if (result.data && result.data.dataRow != null) {
  //       this.initParent(result);
  //     }
  //   });
  // }

  initParent(rs: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;
    this.parentDocuments = rs.data.dataRow;

    this.parentDocuments.forEach(parent => {
      parent.taxCode = (parent.customerTaxCode == null || parent.customerTaxCode === '') ?
        parent.customerCertificateNo : parent.customerTaxCode;
      parent['STT'] = stt++;
      this.childPaginateList[parent.id] = new Paginate();
      this.childOldDataList[parent.id] = new Document();
      this.childSortList[parent.id] = new MatSort();
    });
    this.initDataSelected();
    this.dataSource.data = this.parentDocuments;
    this.childIsExpanding = []; // close all parent
  }

  initDataSelected() {
    if (this.dataSelected.size === 0) {
      this.checkAll = false;
      return;
    }
    for (let i = 0; i < this.parentDocuments.length; i++) {
      if (this.dataSelected.has(this.parentDocuments[i].id)) {
        this.parentDocuments[i].checked = true;
      }
    }

    for (let i = 0; i < this.parentDocuments.length; i++) {
      if (!this.dataSelected.has(this.parentDocuments[i].id)) {
        this.checkAll = false;
        break;
      }
      if (i === this.parentDocuments.length - 1) {
        this.checkAll = true;
      }
    }
  }

  assignGroup() {
    const dialog = this.dialog.open(AssignGroupCustomerDialogComponent, {
      width: '80%',
      data: {
        selectedCustomer: Array.from(this.dataSelected.values()),
        isAssign: true
      }
    })

    dialog.afterClosed().subscribe(rs => {
      if (rs) {
        Array.from(this.dataSelected.values()).forEach(item => {
          item.checked = false;
        });
        this.dataSelected.clear();
        this.checkCheckAll();
        this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
      }
    })
  }

  removeAssignGroup() {
    const dialog = this.dialog.open(AssignGroupCustomerDialogComponent, {
      width: '80%',
      data: {
        selectedCustomer: Array.from(this.dataSelected.values()),
        isAssign: false
      }
    })

    dialog.afterClosed().subscribe(rs => {
      if (rs) {
        Array.from(this.dataSelected.values()).forEach(item => {
          item.checked = false;
        });
        this.dataSelected.clear();
        this.checkCheckAll();
        this.onFilterCustomers(this.paginate.currentPage, this.paginate.pageSize);
      }
    })
  }

  openDialogSync() {
    const dialogRef = this.dialog.open(DialogSyncCustomerComponent, {
      width: '95%',
      maxWidth: '95vw',
      panelClass: 'synchronized-overlay-dialog'
    })
    dialogRef.afterClosed().subscribe((rs) => {
      if (rs) this.loadData()
    })
  }


  cutSpace(){
    this.customer.customerCode = this.customer.customerCode.replace(/\s/g,'')
  }

  checkNavCus(){
    if(this.checkRouterSSO() == true){
      return
    }else{
      this.router.navigateByUrl('/home-enterprise/add-customer')
    }
  }

  checkRouterSSO(): boolean{
    if( localStorage.getItem('isFromSSO') =='true'){
      window.open(this.sme_hub+'/admin/object-management','_blank');
      return true
    }
    return false
  }

  checkDisplayFullList() {
    if(this.isDefaultAdmin) {
      return true;
    }
    if(this.permissions.includes(402) || this.permissions.includes(403) || this.permissions.includes(4)) {
      return true;
    }
    return false;
  }

  checkDisplayBtnMore() {
    if(this.isDefaultAdmin) {
      return true;
    }
    if(this.permissions.includes(4)) {
      return true;
    }
    if(!this.permissions.includes(401) && this.permissions.includes(402) && !this.permissions.includes(403) && !this.permissions.includes(404) && !this.permissions.includes(405)) {
      return false;
    }
    if(this.permissions.includes(401) || this.permissions.includes(402) || this.permissions.includes(403) || this.permissions.includes(404) || this.permissions.includes(405)) {
      return true;
    }
    return false;
  }

  checkDisplayBtnAddCustomer() {
    if(this.isDefaultAdmin) {
      return true;
    }
    if(this.permissions.includes(4)) {
      return true;
    }
    if(this.permissions.includes(401)) {
      return true;
    }
    return false;
  }

  checkDisplayBtnUpdateOrDeleteCustomer(data) {
    if(this.isDefaultAdmin) {
      return true;
    }
    if(this.permissions.includes(4)) {
      return true;
    }
    if(this.permissions.includes(401) && data.createdBy === this.userId) {
      return true;
    }
    if(this.permissions.includes(403)) {
      return true;
    }
    return false;
  }

  checkDisplayBtnDeleteLotCustomer() {
    if(this.isDefaultAdmin) {
      return true;
    }
    if(this.permissions.includes(4)) {
      return true;
    }
    if(this.permissions.includes(401)) {
      return true;
    }
    if(this.permissions.includes(403)) {
      return true;
    }
    return false;
  }

  checkDisplayBtnExportCustomer() {
    if(this.isDefaultAdmin) {
      return true;
    }
    if(this.permissions.includes(4)) {
      return true;
    }
    if(this.permissions.includes(405)) {
      return true;
    }
    return false;
  }

  checkDisplayBtnAssignGroup() {
    if(this.isDefaultAdmin) {
      return true;
    }
    if(this.permissions.includes(4)) {
      return true;
    }
    if(this.permissions.includes(404)) {
      return true;
    }
    return false;
  }

  checkDisplayBtnSync() {
    if(this.isDefaultAdmin) {
      return true;
    }
    if(this.permissions.includes(4)) {
      return true;
    }
    if(this.permissions.includes(401) || this.permissions.includes(402) || this.permissions.includes(403)) {
      return true;
    }
    return false;
  }

}
